/** A lane endpoint as it appears on a staged confirmation payload. */
export interface StagedPlace {
  name?: string;
  city?: string;
  fullAddress?: string;
  savedLocationId?: string;
}

export interface StagedPlaceLabels {
  /**
   * What a route line says. "الرياض → عرعر" reads the same in the card
   * header, the WhatsApp bundle, and the order list; a warehouse name in
   * that slot reads as a different trip every time the pickup changes.
   */
  city?: string;
  /**
   * The specific spot inside that city — a saved warehouse, a pin's
   * neighbourhood. Rendered beside the city, never instead of it, and
   * omitted when it would just repeat the city.
   */
  place?: string;
}

/**
 * Split a staged lane endpoint into the city that names the route and
 * the place that qualifies it.
 *
 * Every surface used to pick its own favourite field — the card header
 * showed `name`, WhatsApp showed `city`, the prompt snapshot showed
 * `name` — so one order was "مستودع التحميل → Alaziziyah" in the app and
 * "الرياض → عرعر" over WhatsApp. Same order, two routes, and neither
 * told the user both facts.
 */
export const stagedPlaceLabels = (loc?: StagedPlace): StagedPlaceLabels => {
  if (!loc) return {};

  const name = loc.name?.trim() || undefined;
  const city =
    loc.city?.trim() ||
    name ||
    loc.fullAddress?.split(',')[0]?.trim() ||
    undefined;

  return { city, place: name && name !== city ? name : undefined };
};
